"use client"
import dynamic from "next/dynamic"
import MetaTags from "@/components/meta-tag/meta-tag"

const ContactInfo = dynamic(() => import("@/components/common/contact-info"))
const ContactForm = dynamic(() => import("@/components/common/contact-form"))

const Page = () => {
  return (
    <>
      <MetaTags />
      <div className="section bg-primary py-100 dark:text-light dark:bg-black">
        <div className="container lg:container md:mx-auto">
          <div className="row grid md:grid-cols-12 lg:grid-cols-12">
            <ContactForm />
            <ContactInfo />
          </div>
        </div>
      </div>
    </>
  )
}

export default Page
